export const AlertColors = {
    success: "#348F41",
    error: "#F32735",
    info: "#1ECAD3",
    warning: "#DBB000",
  };